import React, { Component } from 'react';
import Grid from '../layout/grid';
import 'summernote/dist/summernote-bs4.css';
import 'summernote/dist/summernote-bs4.js';

class LabelAndSummernote extends Component {

	componentDidMount() {

		this.inicializarEditor();
	}


	componentDidUpdate(prevProps) {

		const $ = window.$;

		if (
			!$ ||
			!this.editor ||
			!$.fn.summernote
		) {
			return;
		}

		const valorAtual =
			$(this.editor).summernote('code');

		const novoValor =
			this.props.value || '';

		if (
			prevProps.value !== this.props.value &&
			valorAtual !== novoValor
		) {

			$(this.editor).summernote(
				'code',
				novoValor
			);
		}
	}


	componentWillUnmount() {

		const $ = window.$;

		if (
			$ &&
			this.editor &&
			$.fn.summernote
		) {

			try {
				$(this.editor).summernote('destroy');
			} catch (e) {

			}
		}
	}


	inicializarEditor() {

		const $ = window.$;

		if (
			!$ ||
			!this.editor ||
			!$.fn.summernote
		) {
			return;
		}

		const componente = this;

		$(this.editor).summernote({

			height:
				this.props.height || 180,

			toolbar: [
				[
					'font',
					[
						'bold',
						'italic',
						'underline'
					]
				],
				[
					'para',
					[
						'ul',
						'ol'
					]
				]
			],

			callbacks: {

				onChange: function(contents) {

					if (
						componente.props.onChange
					) {

						componente.props.onChange(
							contents
						);
					}
				}
			}
		});


		$(this.editor).summernote(
			'code',
			this.props.value || ''
		);


		if (this.props.readOnly) {

			$(this.editor).summernote(
				'disable'
			);
		}
	}


	render() {

		return (
			<Grid
				cols={
					this.props.cols ||
					'12 12 12 12'
				}
			>

				<div className='form-group'>

					{this.props.label &&
						<label>
							{this.props.label}
						</label>
					}

					<textarea
						ref={ref => {
							this.editor = ref;
						}}
						defaultValue={
							this.props.value || ''
						}
					/>

				</div>

			</Grid>
		);
	}
}

export default LabelAndSummernote;